import { defineMessages } from "react-intl";

export const ERROR_MESSAGES = defineMessages({
  wayflyerHome: {
    id: "Wayflyer home",
    defaultMessage: "Wayflyer home",
  },
});
